module.exports = __webpack_public_path__ + "img/logo-signathor.f278b4d5.webp";